import React, { useEffect } from "react";
import DTO from "../../assets/vw/svg/dto.svg";
import iconMenu from "../../assets/vw/svg/menu.svg";
import iconCerrar from "../../assets/vw/svg/cerrar.svg";

function Menu() {
  const origin = window.location.origin;
  const pathname = window.location.pathname;
  const rolEnv = process.env.REACT_APP_ROL
  const rutasDEV = process.env.REACT_APP_RUTAS_DEV ? process.env.REACT_APP_RUTAS_DEV.split(",") : [];
const rutasAdmin = process.env.REACT_APP_RUTAS_ADMIN ? process.env.REACT_APP_RUTAS_ADMIN.split(",") : [];
  const [menuItems, setMenu] = React.useState([]);

  useEffect(() => {
    const menu = getMenuFromLocalStorage();
    if(menu === null) {
      alert("No se encontró el menú en el localStorage. Por favor, asegúrese de que el menú esté configurado correctamente.");
      setMenu([]);
      return;
    }
    
    if (menu && menu.length > 0) {
      const urls = menu.map(item => item.url);
      const paths = urls.filter(item => item.startsWith("http") || item.startsWith("https"));
      setMenu(paths);
    }

    if (origin.includes("localhost")) {
      // Rutas predeterminadas para dev
      if(rolEnv === "DEV")
        setMenu(rutasDEV)
      else if(rolEnv === "ADMIN")
        setMenu(rutasAdmin)
      else
        setMenu([]);
      return
    }

  }, []);

  function getMenuFromLocalStorage() {
    const tranc = localStorage.getItem("_tranc");
    if (!tranc) {
      console.error("No se encontró el menú en el localStorage.");
      return null;
    }
  
    try {
      const decodedTranc = JSON.parse(Buffer.from(tranc, 'base64').toString('ascii'));
      return decodedTranc.menu || null; // Retorna el menú si existe
    } catch (error) {
      console.error("Error al decodificar el menú desde el localStorage:", error.stack || error);
      return null;
    }
  }

  function contains(path) {
    return menuItems.some(item => item.includes(path));
  }

  return (
    <>
    <div className="d-none d-sm-none d-md-none d-lg-block">
      <div className="d-flex flex-column menu-vw">
        <div className="d-flex justify-content-center my-3 ">
          <img src={DTO} alt="" />
        </div>
        <hr />
        <ul className="nav nav-pills flex-column mb-auto ps-5 kit_icon">
          { contains("aplicaciones") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/aplicaciones" ? "a-active" : ""
                }`}
                href="/vw/admin/aplicaciones"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/aplicaciones"
                          ? "icon-aplicaciones-active mx-3"
                          : "icon-aplicaciones mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Aplicaciones</div>
                </div>
              </a>
            </li>
          }

          { contains("transacciones") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/transacciones" ? "a-active" : ""
                }`}
                href="/vw/admin/transacciones"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/transacciones"
                          ? "icon-transacciones-active mx-3"
                          : "icon-transacciones mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Transacciones</div>
                </div>
              </a>
            </li>
          }
          { contains("concesionarias") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/concesionarias" ? "a-active" : ""
                }`}
                href="/vw/admin/concesionarias"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/concesionarias"
                          ? "icon-concesionaria-active mx-3"
                          : "icon-concesionaria mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Concesionarias</div>
                </div>
              </a>
            </li>
          }
          { contains("canales") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/canales" ? "a-active" : ""
                }`}
                href="/vw/admin/canales"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/canales"
                          ? "icon-canales-active mx-3"
                          : "icon-canales mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Canales</div>{" "}
                </div>
              </a>
            </li>
          }
          { contains("estados") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/estados" ? "a-active" : ""
                }`}
                href="/vw/admin/estados"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/estados"
                          ? "icon-estados-active mx-3"
                          : "icon-estados mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Estados</div>
                </div>
              </a>
            </li>
          }
          { contains("accesospermanentes") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/accesospermanentes" ? "a-active" : ""
                }`}
                href="/vw/admin/accesospermanentes"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/accesospermanentes"
                          ? "icon-accesos-active mx-3"
                          : "icon-accesos mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Accesos permanentes</div>{" "}
                </div>
              </a>
            </li>
          }
          { contains("destinatarios") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/destinatarios" ? "a-active" : ""
                }`}
                href="/vw/admin/destinatarios"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/destinatarios"
                          ? "icon-destinatarios-active mx-3"
                          : "icon-destinatarios mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Centro de destinatarios </div>{" "}
                </div>
              </a>
            </li>
          }
          { contains("tipoautenticacion") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/tipoautenticacion" ? "a-active" : ""
                }`}
                href="/vw/admin/tipoautenticacion"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/tipoautenticacion"
                          ? "icon-autentificacion-active mx-3"
                          : "icon-autentificacion mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Tipo de autenticación </div>
                </div>
              </a>
            </li>
          }
          { contains("usuarioxaplicacion") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/usuarioxaplicacion" ? "a-active" : ""
                }`}
                href="/vw/admin/usuarioxaplicacion"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/usuarioxaplicacion"
                          ? "icon-usuarios-active mx-3"
                          : "icon-usuarios mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo"> Usuarios por aplicación </div>{" "}
                </div>
              </a>
            </li>
          }
          { contains("permisosrol") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/permisosrol" ? "a-active" : ""
                }`}
                href="/vw/admin/permisosrol"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/permisosrol"
                          ? "icon-permisos-active mx-3"
                          : "icon-permisos mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo"> Permisos por rol</div>
                </div>
              </a>
            </li>
          }
          { contains("roles") &&
            <li className="py-3">
              <a
                className={`${pathname === "/vw/admin/roles" ? "a-active" : ""}`}
                href="/vw/admin/roles"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/roles"
                          ? "icon-rol-active mx-3"
                          : "icon-rol mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Rol</div>
                </div>
              </a>
            </li>
          }
          { contains("comunicados") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/comunicados" ? "a-active" : ""
                }`}
                href="/vw/admin/comunicados"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/comunicados"
                          ? "icon-comunicados-active mx-3"
                          : "icon-comunicados mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Comunicados</div>
                </div>
              </a>
            </li>
          }
          { contains("notificacionesusuario") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/admin/notificacionesusuario" ? "a-active" : ""
                }`}
                href="/vw/admin/notificacionesusuario"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/admin/notificacionesusuario"
                          ? "icon-notificaciones-active mx-3"
                          : "icon-notificaciones mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo"> Notificaciones</div>
                </div>
              </a>
            </li>
          }
          { contains("reporteador") &&
            <li className="py-3">
              <a href="/">
                <div className="row">
                  <div className="col-3">
                    <span className={`${"icon-reporteador mx-3"}`}> </span>
                  </div>
                  <div className="col-9 titulo"> Permisos reporteador</div>{" "}
                </div>
              </a>
            </li>
          }
          { contains("avisos") &&
            <li className="py-3">
              <a
                  className={`${
                    pathname === "/vw/admin/avisos" ? "a-active" : ""
                  }`}
                  href="/vw/admin/avisos"
                >
                <div className="row">
                  <div className="col-3">
                  <span
                      className={`${
                        pathname === "/vw/admin/avisos"
                          ? "icon-avisos-active mx-3"
                          : "icon-avisos mx-3"
                      }`}
                    >
                      {" "}
                    </span>                
                  </div>
                  <div className="col-9 titulo"> Avisos</div>{" "}
                </div>
              </a>
            </li>
          }
          { contains("monitoreos") &&
            <li className="py-3">
              <a
                  className={`${
                    pathname === "/vw/especialista/monitoreos" ? "a-active" : ""
                  }`}
                  href="/vw/especialista/monitoreos"
                >
                <div className="row">
                  <div className="col-3">
                  <span
                      className={`${
                        pathname === "/vw/especialista/monitoreos"
                          ? "icon-monitoreos-active mx-3"
                          : "icon-monitoreos mx-3"
                      }`}
                    >
                      {" "}
                    </span>                </div>
                  <div className="col-9 titulo"> Monitoreo</div>{" "}
                </div>
              </a>
            </li>
          }

          { contains("libreria") &&
            <li className="py-3">
              <a
                className={`${
                  pathname === "/vw/especialista/libreria" ? "a-active" : ""
                }`}
                href="/vw/especialista/libreria"
              >
                <div className="row">
                  <div className="col-3">
                    <span
                      className={`${
                        pathname === "/vw/especialista/libreria"
                          ? "icon-libreria-active mx-3"
                          : "icon-libreria mx-3"
                      }`}
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="col-9 titulo">Librería</div>
                </div>
              </a>
            </li>
          }
          { contains("polly") &&
            <li className="py-3">
              <a
                  className={`${
                    pathname === "/vw/especialista/polly" ? "a-active" : ""
                  }`}
                  href="/vw/especialista/polly"
                >
                <div className="row">
                  <div className="col-3">
                  <span
                      className={`${
                        pathname === "/vw/especialista/polly"
                          ? "icon-polly-active mx-3"
                          : "icon-polly mx-3"
                      }`}
                    >
                      {" "}
                    </span>                </div>
                  <div className="col-9 titulo"> Polly</div>{" "}
                </div>
              </a>
            </li>
          }
          { contains("logs") &&
            <li className="py-3">
              <a
                  className={`${
                    pathname === "/vw/especialista/logs" ? "a-active" : ""
                  }`}
                  href="/vw/especialista/logs"
                >
                <div className="row">
                  <div className="col-3">
                  <span
                      className={`${
                        pathname === "/vw/especialista/logs"
                          ? "icon-logs-active mx-3"
                          : "icon-logs mx-3"
                      }`}
                    >
                      {" "}
                    </span>                </div>
                  <div className="col-9 titulo"> Logs</div>{" "}
                </div>
              </a>
            </li>
          }
        </ul>
        <hr />
      </div>
    </div>

    <div className="d-block d-sm-block d-md-block d-lg-none">
      <nav className="navbar bg-body-tertiary fixed-top  ">
          {/*<button*/}
          {/*  className="navbar-toggler"*/}
          {/*  type="button"*/}
          {/*  data-bs-toggle="offcanvas"*/}
          {/*  data-bs-target="#offcanvasNavbar"*/}
          {/*  aria-controls="offcanvasNavbar"*/}
          {/*  aria-label="Toggle navigation"*/}
          {/*>*/}
          {/*  <img src={iconMenu} alt="" />*/}
          {/*</button>*/}
          <div
            className="offcanvas offcanvas-start menu-navbar"
            tabIndex="1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div className="offcanvas-header ps-4">
            <div className="offcanvas-title" id="offcanvasNavbarLabel">Menú</div>

              <button
                type="button"
                className="navbar-toggler"
                data-bs-dismiss="offcanvas"
              >
                <img src={iconCerrar} alt="" />
              </button>
            </div>
            <div className="offcanvas-body menu-vw pt-0">
              <ul className="nav nav-pills flex-column mb-auto ps-4 kit_icon">
                { contains("aplicaciones") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/aplicaciones" ? "a-active" : ""
                      }`}
                      href="/vw/admin/aplicaciones"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/aplicaciones"
                                ? "icon-aplicaciones-active mx-3"
                                : "icon-aplicaciones mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Aplicaciones</div>
                      </div>
                    </a>
                  </li>
                }
                { contains("transacciones") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/transacciones" ? "a-active" : ""
                      }`}
                      href="/vw/admin/transacciones"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/transacciones"
                                ? "icon-transacciones-active mx-3"
                                : "icon-transacciones mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Transacciones</div>
                      </div>
                    </a>
                  </li>
                }
                { contains("concesionarias") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/concesionarias" ? "a-active" : ""
                      }`}
                      href="/vw/admin/concesionarias"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/concesionarias"
                                ? "icon-concesionaria-active mx-3"
                                : "icon-concesionaria mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Concesionarias</div>
                      </div>
                    </a>
                  </li>
                }
                { contains("canales") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/canales" ? "a-active" : ""
                      }`}
                      href="/vw/admin/canales"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/canales"
                                ? "icon-canales-active mx-3"
                                : "icon-canales mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Canales</div>{" "}
                      </div>
                    </a>
                  </li>
                }
                { contains("estados") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/estados" ? "a-active" : ""
                      }`}
                      href="/vw/admin/estados"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/estados"
                                ? "icon-estados-active mx-3"
                                : "icon-estados mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Estados</div>
                      </div>
                    </a>
                  </li>
                }
                { contains("accesospermanentes") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/accesospermanentes" ? "a-active" : ""
                      }`}
                      href="/vw/admin/accesospermanentes"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/accesospermanentes"
                                ? "icon-accesos-active mx-3"
                                : "icon-accesos mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Accesos permanentes</div>{" "}
                      </div>
                    </a>
                  </li>
                }
                { contains("destinatarios") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/destinatarios" ? "a-active" : ""
                      }`}
                      href="/vw/admin/destinatarios"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/destinatarios"
                                ? "icon-destinatarios-active mx-3"
                                : "icon-destinatarios mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Centro de destinatarios </div>{" "}
                      </div>
                    </a>
                  </li>
                }
                { contains("tipoautenticacion") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/tipoautenticacion" ? "a-active" : ""
                      }`}
                      href="/vw/admin/tipoautenticacion"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/tipoautenticacion"
                                ? "icon-autentificacion-active mx-3"
                                : "icon-autentificacion mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Tipo de autenticación </div>
                      </div>
                    </a>
                  </li>
                }
                { contains("usuarioxaplicacion") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/usuarioxaplicacion" ? "a-active" : ""
                      }`}
                      href="/vw/admin/usuarioxaplicacion"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/usuarioxaplicacion"
                                ? "icon-usuarios-active mx-3"
                                : "icon-usuarios mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile"> Usuarios por aplicación </div>{" "}
                      </div>
                    </a>
                  </li>
                }
                { contains("permisosrol") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/permisosrol" ? "a-active" : ""
                      }`}
                      href="/vw/admin/permisosrol"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/permisosrol"
                                ? "icon-permisos-active mx-3"
                                : "icon-permisos mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile"> Permisos por rol</div>
                      </div>
                    </a>
                  </li>
                }
                { contains("roles") &&
                  <li className="py-3">
                    <a
                      className={`${pathname === "/vw/admin/roles" ? "a-active" : ""}`}
                      href="/vw/admin/roles"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/roles"
                                ? "icon-rol-active mx-3"
                                : "icon-rol mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Rol</div>
                      </div>
                    </a>
                  </li>
                }
                { contains("comunicados") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/comunicados" ? "a-active" : ""
                      }`}
                      href="/vw/admin/comunicados"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/comunicados"
                                ? "icon-comunicados-active mx-3"
                                : "icon-comunicados mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Comunicados</div>
                      </div>
                    </a>
                  </li>
                }
                { contains("notificacionesusuario") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/admin/notificacionesusuario" ? "a-active" : ""
                      }`}
                      href="/vw/admin/notificacionesusuario"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/admin/notificacionesusuario"
                                ? "icon-notificaciones-active mx-3"
                                : "icon-notificaciones mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile"> Notificaciones</div>
                      </div>
                    </a>
                  </li>
                }
                { contains("reporteador") &&
                  <li className="py-3">
                    <a href="/">
                      <div className="row">
                        <div className="col-3">
                          <span className={`${"icon-reporteador mx-3"}`}> </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile"> Permisos reporteador</div>{" "}
                      </div>
                    </a>
                  </li>
                }
                { contains("avisos") &&
                  <li className="py-3">
                    <a
                        className={`${
                          pathname === "/vw/admin/avisos" ? "a-active" : ""
                        }`}
                        href="/vw/admin/avisos"
                      >
                      <div className="row">
                        <div className="col-3">
                        <span
                            className={`${
                              pathname === "/vw/admin/avisos"
                                ? "icon-avisos-active mx-3"
                                : "icon-avisos mx-3"
                            }`}
                          >
                            {" "}
                          </span>                
                        </div>
                        <div className="col-9 titulo-menu-mobile"> Avisos</div>{" "}
                      </div>
                    </a>
                  </li>
                }
                { contains("monitoreos") &&
                  <li className="py-3">
                    <a
                        className={`${
                          pathname === "/vw/especialista/monitoreos" ? "a-active" : ""
                        }`}
                        href="/vw/especialista/monitoreos"
                      >
                      <div className="row">
                        <div className="col-3">
                        <span
                            className={`${
                              pathname === "/vw/especialista/monitoreos"
                                ? "icon-monitoreos-active mx-3"
                                : "icon-monitoreos mx-3"
                            }`}
                          >
                            {" "}
                          </span>                </div>
                        <div className="col-9 titulo-menu-mobile"> Monitoreo</div>{" "}
                      </div>
                    </a>
                  </li>
                }

                { contains("libreria") &&
                  <li className="py-3">
                    <a
                      className={`${
                        pathname === "/vw/especialista/libreria" ? "a-active" : ""
                      }`}
                      href="/vw/especialista/libreria"
                    >
                      <div className="row">
                        <div className="col-3">
                          <span
                            className={`${
                              pathname === "/vw/especialista/libreria"
                                ? "icon-libreria-active mx-3"
                                : "icon-libreria mx-3"
                            }`}
                          >
                            {" "}
                          </span>
                        </div>
                        <div className="col-9 titulo-menu-mobile">Librería</div>
                      </div>
                    </a>
                  </li>
                }

                { contains("polly") &&
                  <li className="py-3">
                    <a
                        className={`${
                          pathname === "/vw/especialista/polly" ? "a-active" : ""
                        }`}
                        href="/vw/especialista/polly"
                      >
                      <div className="row">
                        <div className="col-3">
                        <span
                            className={`${
                              pathname === "/vw/especialista/polly"
                                ? "icon-polly-active mx-3"
                                : "icon-polly mx-3"
                            }`}
                          >
                            {" "}
                          </span>                </div>
                        <div className="col-9 titulo-menu-mobile"> Polly</div>{" "}
                      </div>
                    </a>
                  </li>
                }
                { contains("logs") &&
                  <li className="py-3">
                    <a
                        className={`${
                          pathname === "/vw/especialista/logs" ? "a-active" : ""
                        }`}
                        href="/vw/especialista/logs"
                      >
                      <div className="row">
                        <div className="col-3">
                        <span
                            className={`${
                              pathname === "/vw/especialista/logs"
                                ? "icon-logs-active mx-3"
                                : "icon-logs mx-3"
                            }`}
                          >
                            {" "}
                          </span>                </div>
                        <div className="col-9 titulo-menu-mobile"> Logs</div>{" "}
                      </div>
                    </a>
                  </li>
                }
              </ul>
            </div>
          </div>
      </nav>
      </div>
    </>
  );
}

export default Menu;
